import { logError } from './logger';

/**
 * 讓同一個瀏覽器的所有分頁**輪流**執行 `task`（Web Locks API）。
 *
 * 分頁內的去重（http.ts 的 `refreshOnce`、auth store 的 `bootstrapPromise`）擋不到跨分頁的事：
 * 那些是模組變數，每個分頁各一份。而 cookie 是所有分頁共用的。
 *
 * 不支援的環境（非 https 的來源、太舊的瀏覽器）直接執行——鎖是保險，不是前提。
 */
export async function withTabLock<T>(name: string, task: () => Promise<T>): Promise<T> {
  const locks = typeof navigator === 'undefined' ? undefined : navigator.locks;

  if (locks === undefined) {
    return task();
  }

  let started = false;

  try {
    return await locks.request(name, () => {
      started = true;
      return task();
    });
  } catch (error) {
    // task 自己的失敗原樣丟回去：再跑一次正是呼叫端想用這把鎖避免的事
    if (started) {
      throw error;
    }

    // 鎖本身拿不到（例如 sandbox iframe 的 opaque origin 會丟 SecurityError）
    logError('分頁鎖拿不到，改成直接執行', error, { name });
    return task();
  }
}
